"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var withDecoratorsStyles = "\ndisplay: flex;\njustify-content: space-between;";
exports.Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var withDecorators = _a.withDecorators;
    return withDecorators && withDecoratorsStyles;
});
var templateObject_1;
//# sourceMappingURL=root.js.map